import moment from 'moment';
import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    /**
     * 快速下单
     */
    // 语言切换
    orderReporttype: '1',
    areaOne: '',
    areaTow: '',
    areaThree: '',
    // 验货类型切换
    orderType: '1',
    //  表单提交数据
    goodsDataList: {},
    downOrder: {},
    // 验货下单返回数据
    dataOrder: false,
    // 验货订单保存草稿箱返回数据
    draftsState: false,
    //三级联动
    preCiy: [],
    user: {},
  },
  actions: {
    /**
     * 验货订单下单
     */
    async startOrderDown({ commit }, data) {
      console.log('data', data);
      const formDataMap = data.formDataMap;
      const orderType = data.orderType;
      const tableDataList = data.tableDataList;
      const fileList = data.fileList.fileId;
      console.log('====fileLis1122t=====', fileList);
      console.log('====f222ormDataMap=====', formDataMap);
      const orState = data.orState;
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user'));
      }
      const userId = this.user !== {} ? this.user.id : '';
      let date = '';
      // 区域
      let areaList = '';
      console.log('formDataMap========', formDataMap);
      if (
        formDataMap !== null &&
        formDataMap !== '' &&
        formDataMap !== undefined &&
        formDataMap !== {} &&
        JSON.stringify(formDataMap) !== '{}'
      ) {
        let lang = '';
        // 获取国际化sessionStorage信息
        if (sessionStorage.getItem('lang') !== null) {
          lang = JSON.parse(sessionStorage.getItem('lang')) || '';
        }
        if (formDataMap.orderFactoryarea !== undefined && lang !== 'en-US') {
          console.log('formDataMap', formDataMap);
          const areaOne = formDataMap.orderFactoryarea[0];
          const areaTow = formDataMap.orderFactoryarea[1];
          const areaThree = formDataMap.orderFactoryarea[2];
          // 时间格式YYYYMMDDHHmmss
          //  日期转换
          date = moment(formDataMap.orderServicedate).format('YYYY-MM-DD');
          // 拼接省市区
          if (areaThree !== undefined) {
            areaList = areaOne + '/' + areaTow + '/' + areaThree;
          } else {
            areaList = areaOne + '/' + areaTow;
          }
        }
        if (lang === 'en-US') {
          areaList = '北京市/市辖区';
        }
        const orderReporttype = data.orderReporttype;

        const resData = await this.$http.post('/hzwmj/workorder/addWorkOrder', {
          orderFactoryname: formDataMap.orderFactoryname,
          orderFactoryarea: areaList,
          orderFactoryaddress: formDataMap.orderFactoryaddress,
          orderFactoryperson: formDataMap.orderFactoryperson,
          orderFactoryfixedtel: formDataMap.orderFactoryfixedtel,
          orderFactorytel: formDataMap.orderFactorytel,
          orderFactoryemail: formDataMap.orderFactoryemail,
          orderTrustcompany: formDataMap.orderTrustcompany,
          orderTrustaddress: formDataMap.orderTrustaddress,
          orderTrustperson: formDataMap.orderTrustperson,
          orderTrustfixedtel: formDataMap.orderTrustfixedtel,
          orderTrusttel: formDataMap.orderTrusttel,
          orderTrustemail: formDataMap.orderTrustemail,
          orderdate: date,
          orderRequire: formDataMap.orderRequire,
          //订单类型（服务类型）
          orderType: orderType,
          orderReporttype: orderReporttype,
          // 产品数据
          productlist: tableDataList,
          fileList: fileList,
          // 检验标准
          orderStandard:
            orderType == 3
              ? 'ASTM D5430 Four Point System(四分制评分法)'
              : 'ANSI/ASQ Z1.4 Single Sampling Plan',
          orderFabrilevelone: formDataMap.Inspection_Level == 1 ? '1' : null,
          orderFabrileveltwo: formDataMap.orderFabrileveltwo
            ? String(formDataMap.orderFabrileveltwo)
            : null,
          orderFabrilevelthree: formDataMap.orderFabrilevelthree
            ? String(formDataMap.orderFabrilevelthree)
            : null,
          orderFabriacceptone: formDataMap.productNumber
            ? String(formDataMap.productNumber)
            : null,
          orderFabriaccepttwo: formDataMap.productNumber1
            ? String(formDataMap.productNumber1)
            : null,
          //检验水平
          // orderLevel: formDataMap.aql,
          orderLevel: 'AQL Level II',
          //致命缺陷
          // orderFataldefect: formDataMap.criterion,
          orderFataldefect: '0',
          //严重缺陷
          // orderSeriousdefect: formDataMap.serious,
          orderSeriousdefect: '2.5',
          //轻微缺陷
          // orderMinordefect: formDataMap.slight,
          orderMinordefect: '4.0',
          // 订单状态：0下单，草稿箱10
          orderState: orState === 10 ? '10' : '0',
          //检验资料/款式附件
          orderAnnex: fileList,
          trustpersonId: userId,
          // 订单号
          orderIdNum: data.orderIdFrom,
        });
        if (resData.code === 200) {
          if (orState === 10) {
            if (resData.data === true) {
              console.log('订单保存草稿箱成功');
              // this.dataOrder = false;
              message.success('订单保存草稿箱成功');
              const draftsState = resData.data;
              console.log('draftsState', draftsState);
              commit('save', { draftsState });
            } else {
              message.error('订单保存草稿箱失败');
              const draftsState = resData.data;
              console.log('draftsState', draftsState);
              commit('save', { draftsState });
            }
          } else {
            if (resData.data === true) {
              message.success('生成订单成功');
            } else {
              message.error('生成订单失败');
            }
          }
          const dataOrder = resData.data;
          console.log('dataOrder', dataOrder);
          commit('save', { dataOrder });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      }
    },
    /**
     * 验货订单修改下单
     */
    async updateWorkOrder({ commit }, data) {
      console.log('data', data);
      const formDataMap = data.formDataMap;
      const orderType = data.orderType;
      const tableDataList = data.tableDataList;
      const fileList = data.fileList.fileId;
      console.log('====fileList=====', fileList);
      const orState = data.orState;
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user'));
      }
      const userId = this.user !== {} ? this.user.id : '';
      let date = '';
      // 区域
      let areaList = '';
      if (
        formDataMap !== null &&
        formDataMap !== '' &&
        formDataMap !== undefined &&
        formDataMap !== {} &&
        JSON.stringify(formDataMap) !== '{}'
      ) {
        let lang = '';
        // 获取国际化sessionStorage信息
        if (sessionStorage.getItem('lang') !== null) {
          lang = JSON.parse(sessionStorage.getItem('lang')) || '';
        }
        if (formDataMap.orderFactoryarea !== undefined && lang !== 'en-US') {
          console.log('formDataMap', formDataMap);
          const areaOne = formDataMap.orderFactoryarea[0];
          const areaTow = formDataMap.orderFactoryarea[1];
          const areaThree = formDataMap.orderFactoryarea[2];
          // 时间格式YYYYMMDDHHmmss
          //  日期转换
          date = moment(formDataMap.orderServicedate).format('YYYY-MM-DD');
          // 拼接省市区
          if (areaThree !== undefined) {
            areaList = areaOne + '/' + areaTow + '/' + areaThree;
          } else {
            areaList = areaOne + '/' + areaTow;
          }
        }
        if (lang === 'en-US') {
          areaList = '北京市/市辖区';
        }
        const orderReporttype = data.orderReporttype;

        const resData = await this.$http.post(
          '/hzwmj/workorder/updateWorkOrder',
          {
            orderFactoryname: formDataMap.orderFactoryname,
            orderFactoryarea: areaList,
            orderFactoryaddress: formDataMap.orderFactoryaddress,
            orderFactoryperson: formDataMap.orderFactoryperson,
            orderFactoryfixedtel: formDataMap.orderFactoryfixedtel,
            orderFactorytel: formDataMap.orderFactorytel,
            orderFactoryemail: formDataMap.orderFactoryemail,
            orderTrustcompany: formDataMap.orderTrustcompany,
            orderTrustaddress: formDataMap.orderTrustaddress,
            orderTrustperson: formDataMap.orderTrustperson,
            orderTrustfixedtel: formDataMap.orderTrustfixedtel,
            orderTrusttel: formDataMap.orderTrusttel,
            orderTrustemail: formDataMap.orderTrustemail,
            orderdate: date,
            orderRequire: formDataMap.orderRequire,
            //订单类型（服务类型）
            orderType: orderType,
            orderReporttype: orderReporttype,
            // 产品数据
            productlist: tableDataList,
            fileList: fileList,
            // 检验标准
            orderStandard:
              orderType == 3
                ? 'ASTM D5430 Four Point System(四分制评分法)'
                : 'ANSI/ASQ Z1.4 Single Sampling Plan',
            orderFabrilevelone: formDataMap.Inspection_Level == 1 ? '1' : null,
            orderFabrileveltwo: formDataMap.orderFabrileveltwo
              ? String(formDataMap.orderFabrileveltwo)
              : null,
            orderFabrilevelthree: formDataMap.orderFabrilevelthree
              ? String(formDataMap.orderFabrilevelthree)
              : null,
            orderFabriacceptone: formDataMap.productNumber
              ? String(formDataMap.productNumber)
              : null,
            orderFabriaccepttwo: formDataMap.productNumber1
              ? String(formDataMap.productNumber1)
              : null,

            //检验水平
            orderLevel: formDataMap.aql,
            //致命缺陷
            orderFataldefect: formDataMap.criterion,
            //严重缺陷
            orderSeriousdefect: formDataMap.serious,
            //轻微缺陷
            orderMinordefect: formDataMap.slight,
            // 订单状态：0下单，草稿箱10
            orderState: orState === 10 ? '10' : '0',
            //检验资料/款式附件
            orderAnnex: fileList,
            trustpersonId: userId,
            // 订单号
            orderIdNum: data.orderIdFrom,
          },
        );
        if (resData.code === 200) {
          if (orState === 10) {
            if (resData.data === true) {
              message.success('订单保存草稿箱成功');
            } else {
              message.error('订单保存草稿箱失败');
            }
          } else {
            if (resData.data === true) {
              message.success('生成订单成功');
            } else {
              message.error('生成订单失败');
            }
          }
          const dataOrder = resData.data;
          console.log('dataOrder', dataOrder);
          commit('save', { dataOrder });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      }
    },
    //城市三级联动数据取值
    async queryPreCiy({ commit }) {
      const resData = await this.$http.get('/hzwmj/city/queryPreCiy');
      if (resData.code === 200) {
        const preCiy = resData.data;
        commit('save', { preCiy });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
